import BaseModelInstance from './base.model'
import { UserContractCartItem as ModelDefinition } from './model-definitions'

class UserContractCartItem extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserContractCartItem
